import { render, staticRenderFns } from "./ExtraFieldPrint.vue?vue&type=template&id=2ea28e04&scoped=true&"
import script from "./ExtraFieldPrint.vue?vue&type=script&lang=js&"
export * from "./ExtraFieldPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea28e04",
  null
  
)

export default component.exports